/**
 * Which markers a map layer adds, moves and removes when its entries change. Pure: no Leaflet.
 */

/** A marker position, [lat, lng]. */
export type LatLngTuple = readonly [number, number];

/** The ids to add, to move and to remove. */
export interface PositionDiff {
  added: string[];
  moved: string[];
  removed: string[];
}

/**
 * Compare the `next` positions by value with `last`, the positions the layer last emitted, and
 * update `last` to `next`. The diff never reads where a marker shows: markercluster's spiderfy
 * moves a marker on screen, and that is not a move.
 */
export function diffPositions(
  last: Map<string, LatLngTuple>,
  next: Iterable<readonly [string, LatLngTuple]>,
): PositionDiff {
  const added: string[] = [];
  const moved: string[] = [];
  const seen = new Set<string>();
  for (const [id, p] of next) {
    seen.add(id);
    const prev = last.get(id);
    if (!prev) added.push(id);
    else if (prev[0] !== p[0] || prev[1] !== p[1]) moved.push(id);
    else continue;
    last.set(id, p);
  }
  const removed = [...last.keys()].filter((id) => !seen.has(id));
  for (const id of removed) last.delete(id);
  return { added, moved, removed };
}
